module.exports = __webpack_public_path__ + "5b0a4e79501499b361895eb84059b599.svg";